import { render } from "./TestResultAssteacher.vue?vue&type=template&id=bb3a4796&scoped=true"
import script from "./TestResultAssteacher.vue?vue&type=script&lang=js"
export * from "./TestResultAssteacher.vue?vue&type=script&lang=js"

import "./TestResultAssteacher.vue?vue&type=style&index=0&id=bb3a4796&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3a4796"]])

export default __exports__